export default __webpack_public_path__ + "static/media/BrainBreak cards41.91f551f8.png";